import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const TestCategories_List = () => {
    const [List, setList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10;

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");
        const fetchTestsList = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}api/getTests`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                if (Array.isArray(data.data)) {
                    setList(data.data);
                    setFilteredData(data.data);
                } else {
                    console.error('Data is not an array:', data);
                    setList([]);
                    setFilteredData([]);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchTestsList();
    }, []);

    // Search Functionality
    useEffect(() => {
    if (searchQuery.trim() === "") {
        setFilteredData(List);
    } else {
        const filtered = List.filter(item =>
            (item.test_id || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.test_name || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.test_code || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.test_category || "").toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.mapped_test_category || "").toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredData(filtered);
    }
    setCurrentPage(1);
}, [searchQuery, List]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const goToPage = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header-custom d-flex justify-content-between p-4 mb-0 row">
                                    <div className="header-title col-4">
                                        <h4 className="card-title">Test Categories List</h4>
                                    </div>
                                    <div className="header-action col-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-group mb-0">
                                                    <input 
                                                        type="text" 
                                                        className="form-control form-control-sm" 
                                                        placeholder="Search by Name, Code, or Category"
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="d-flex justify-content-end">
                                                    <a href="/add_testslist" className="btn btn-sm btn-primary">Add Test</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="col-12 table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Service ID</th>
                                        <th scope="col">Test Code</th>
                                        <th scope="col">Test Name</th>
                                        <th scope="col">Test Category</th>
                                        <th scope="col">Mapped Test Category</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRecords.length > 0 ? (
                                        currentRecords.map((list, index) => (
                                            <tr key={list.id}>
                                                <th scope="row">{indexOfFirstRecord + index + 1}</th>
                                                <td>{list.test_id}</td>
                                                <td>{list.test_code}</td>
                                                <td>{list.test_name}</td>
                                                <td>{list.test_category}</td>
                                                <td>{list.mapped_test_category}</td>
                                                <td>
                                                    <a href={`/edit_test_list/${list.ts_id}`} className="btn btn-sm btn-primary">Edit</a>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">No records found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-center align-items-center mt-3">
    <nav>
        <ul className="pagination">
            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button 
                    className="page-link" 
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    «
                </button>
            </li>

            {/* Page Numbers */}
            {totalPages > 5 && currentPage > 3 && (
                <li className="page-item">
                    <button className="page-link" onClick={() => goToPage(1)}>1</button>
                </li>
            )}
            {totalPages > 5 && currentPage > 4 && (
                <li className="page-item disabled"><span className="page-link">...</span></li>
            )}

            {Array.from({ length: totalPages }, (_, index) => index + 1)
                .filter(pageNumber => 
                    pageNumber === 1 || 
                    pageNumber === totalPages || 
                    (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                )
                .map(pageNumber => (
                    <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                        <button className="page-link" onClick={() => goToPage(pageNumber)}>
                            {pageNumber}
                        </button>
                    </li>
                ))
            }

            {totalPages > 5 && currentPage < totalPages - 3 && (
                <li className="page-item disabled"><span className="page-link">...</span></li>
            )}
            {totalPages > 5 && currentPage < totalPages - 2 && (
                <li className="page-item">
                    <button className="page-link" onClick={() => goToPage(totalPages)}>
                        {totalPages}
                    </button>
                </li>
            )}

            {/* Next Button */}
            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button 
                    className="page-link" 
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    »
                </button>
            </li>
        </ul>
    </nav>
</div>

                    </div>
                </div>
            </main>
        </div>
    );
};

export default TestCategories_List;
